// removed by extract-text-webpack-plugin
module.exports = {"pending-documents-container":"pending-documents-list__pending-documents-container___2Bz6Q","pending-documents":"pending-documents-list__pending-documents___Rc0Bu","pending-titles":"pending-documents-list__pending-titles___2h5Wv","pending-item":"pending-documents-list__pending-item___1PPrg","pending-button":"pending-documents-list__pending-button___1kkj9","link":"pending-documents-list__link___32EEn","number-pending":"pending-documents-list__number-pending___N1mkL"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/pending-documents-list.scss
// module id = 1370
// module chunks = 0